// extracted by mini-css-extract-plugin
export default {"root":"CountryCard_root__K7mGc","image":"CountryCard_image__Z1yR3","spec":"CountryCard_spec__E1YHx"};